import i18n from "@/i18n";
import { toast } from "sonner";
import { apiErrorNotice, type ApiErrorPolicyOptions } from "@/lib/api-error-policy";

export function showApiErrorToast(error: unknown, options: ApiErrorPolicyOptions): void {
  const notice = apiErrorNotice(error, options);
  toast.error(notice.message, {
    description: notice.requestId
      ? i18n.t("common.apiError.requestId", { id: notice.requestId })
      : undefined,
  });
}
